<template>
  <i class="tm-overlay-badge">
    <i class="-bottom">
      <i class="-duration">
        <i class="t" v-text="overlayDuration" />
      </i>
    </i>
  </i>
</template>

<script>
import { trackTimeFormat } from '../../../../api/tapi';

export default {
  name: 'tmOverlayBadge',

  props: {
    duration: { type: Number, required: true },
  },

  computed: {
    overlayDuration() {
      return trackTimeFormat(this.$props.duration);
    },
  },
};
</script>

<style lang="scss">
.tm-overlay-span > .tm-overlay-badge {
  position: absolute;
  top: 0;
  z-index: var(--tm-zOverlayBadge);
  overflow: hidden;
  pointer-events: none;

  > .-bottom {
    position: absolute;
    left: var(--tm-pxVisualSpanBorder);
    bottom: var(--tm-pxVisualSpanBorder);
    display: flex;
    justify-content: center;
    align-items: stretch;
    height: 24px;
    pointer-events: none;

    > .-duration {
      display: flex;
      align-items: center;
      padding: 0 7px;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;

      > .t {
        font-size: 12px;
        margin-top: 2px;
      }
    }
  }
}
</style>
